/**
* @name: AppSearch
* @author: weiyong
* @date: 2023-09-21 00:14
* @description：AppSearch
* @update: 2023-09-21 00:14
*/
<template>
  <div class="AppSearch">
    <a-tooltip>
      <template #title>{{t('新手指引')}}</template>
      <span @click="openZhiyin">
       <robot-outlined />
      </span>
    </a-tooltip>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "zhiyinUser",
});
</script>

<script lang="ts" setup>
import {RobotOutlined} from "@ant-design/icons-vue";
import {Tooltip as ATooltip} from "ant-design-vue";
import {useI18n} from "@/hooks/web/useI18n";
import {usePageDesHook} from "@/layouts/layoutFrame/hooks/usePageDesHook";
import GoingUtils from "@/utils/goingUtils";
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';

const { t } = useI18n();
const {loadPageDes} = usePageDesHook();
onMounted(()=>{
  const isNewUser=GoingNewUtils.parseBoolean(StorageUtils.getSessionItem("isNewUser")+'');
  if(isNewUser){
    loadPageDes({pageCode:'zhiyinUser',moduleCode:'zhiyinUser',pageTitle:'新手指引'});
  }
})
const openZhiyin=function (){
  loadPageDes({pageCode:'zhiyinUser',moduleCode:'zhiyinUser',pageTitle:'新手指引'});
}
</script>

<style type="text/css" lang="less">
.AppSearch{
  cursor:pointer;
}
</style>
